import React from 'react'
import { Stepper } from '../../pures'
import { useTranslation } from "react-i18next"
import { InstructionsPure } from '../../pures'
import './on-boarding-stepper.css'

/**
 * @author Edgar Escobedo
 * @description Onboarding stepper view component
 * @createdDate 08-10-2025
 * @param {Object} props - Component props 
 * @returns {JSX.Element} The OnBoardingStepperView component
 */
const OnBoardingStepperView = (props) => {
  const {
    selectedStep,
    stepMetadata,
    steps
  } = props
  const { t } = useTranslation()

  const step = steps[selectedStep]
  const { component: StepComponent } = stepMetadata[selectedStep]
  return (
    <div className='onBoardingStepperView-container'>
      <Stepper steps={steps} selectedStep={selectedStep} />
      {selectedStep === 0 && (
        <div className='onBoardingStepperView'>
          <InstructionsPure instructions={t('registerUserInvited.instructions')} />
        </div>
      )}
      <StepComponent
        step={step}
        {...props}
      />
    </div>
  )
}

export { OnBoardingStepperView as default }